import { Button } from "../../uikit";
import TelegramSimple from "img/tgsimple.svg";

import { useTranslation } from "react-i18next";
import { Link } from "react-router";

export default function Start({ setVariant }) {
  const { t, _ } = useTranslation();

  return (
    <div className="column card-internals">
      <Button
        className="row mt-05"
        mode="filled"
        size="l"
        before={<img src={TelegramSimple} alt="" className="monochrome-icon" />}
        onClick={() => setVariant("login-telegram")}
      >
        {t("Log in via telegram")}
      </Button>
      <Button
        className="row"
        mode="outline"
        size="l"
        onClick={() => setVariant("login-email")}
      >
        {t("Log in via email")}
      </Button>
      <div className="text-center mb-1">
        {t("When using the service, you agree to")}{" "}
        <Link href="/termsandpolicies">{t("the terms and policies")}</Link>{" "}
        {t("of the service")}
      </div>
    </div>
  );
}
